// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricing-page {
  background: #f7f9fc;
  color: #1a1a1a;
}

.hero {
  background: linear-gradient(135deg, #071a3d, #0f2f6b);
  color: white;
  padding: 120px 20px;
  text-align: center;
}
.hero .hero-content {
  max-width: 900px;
  margin: auto;
}
.hero .eyebrow {
  color: #7eb6ff;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.hero h1 {
  font-size: 64px;
  font-weight: 800;
  margin: 20px 0;
}
.hero h1 span {
  color: #5aa8ff;
}
.hero p {
  font-size: 20px;
  opacity: 0.9;
  max-width: 700px;
  margin: auto;
}

.hero-buttons {
  margin-top: 40px;
  display: flex;
  gap: 15px;
  justify-content: center;
}

.btn-primary {
  background: #1677ff;
  color: white;
  border: none;
  padding: 14px 32px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
}

.btn-secondary {
  background: transparent;
  border: 1px solid white;
  color: white;
  padding: 14px 32px;
  border-radius: 12px;
  cursor: pointer;
}

.pricing-section {
  margin-top: -70px;
  padding: 0 20px 100px;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: auto;
}

.pricing-card {
  background: white;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.08);
  position: relative;
}
.pricing-card .icon {
  font-size: 40px;
  color: #1677ff;
  margin-bottom: 20px;
}
.pricing-card h2 {
  font-size: 32px;
  margin-bottom: 10px;
}
.pricing-card .price {
  font-size: 52px;
  font-weight: 800;
}
.pricing-card .price span {
  display: block;
  font-size: 16px;
  color: #666;
  font-weight: 500;
}
.pricing-card .description {
  color: #666;
  margin: 20px 0;
}
.pricing-card ul {
  list-style: none;
  padding: 0;
}
.pricing-card ul li {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}
.pricing-card ul li svg {
  color: #22c55e;
}

.featured {
  border: 3px solid #1677ff;
}

.popular-badge {
  position: absolute;
  top: -15px;
  right: 30px;
  background: #1677ff;
  color: white;
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.card-btn {
  width: 100%;
  margin-top: 30px;
  padding: 14px;
  border-radius: 12px;
  border: none;
  background: #1677ff;
  color: white;
  font-weight: 700;
  cursor: pointer;
}

.comparison {
  padding: 80px 20px;
}
.comparison .container {
  max-width: 1200px;
  margin: auto;
}
.comparison h2 {
  text-align: center;
  margin-bottom: 40px;
  font-size: 42px;
}
.comparison table {
  width: 100%;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  border-collapse: collapse;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.08);
}
.comparison table th {
  background: #071a3d;
  color: white;
  padding: 20px;
  text-align: left;
}
.comparison table td {
  padding: 18px 20px;
  border-bottom: 1px solid #eee;
}

.cta {
  background: linear-gradient(135deg, #1677ff, #0055d4);
  color: white;
  text-align: center;
  padding: 100px 20px;
}
.cta svg {
  font-size: 50px;
  margin-bottom: 20px;
}
.cta h2 {
  font-size: 48px;
  margin-bottom: 20px;
}
.cta p {
  font-size: 20px;
  opacity: 0.9;
}
.cta button {
  margin-top: 30px;
  background: white;
  color: #1677ff;
  border: none;
  padding: 16px 36px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 42px;
  }
  .pricing-grid {
    grid-template-columns: 1fr;
  }
  .comparison h2 {
    font-size: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pricing/PricingPage.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,qDAAA;EAMA,YAAA;EACA,mBAAA;EACA,kBAAA;AAJF;AAME;EACE,gBAAA;EACA,YAAA;AAJJ;AAOE;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AALJ;AAQE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AANJ;AAQI;EACE,cAAA;AANN;AAUE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AARJ;;AAYA;EACE,gBAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;AATF;;AAYA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AATF;;AAYA;EACE,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AATF;;AAYA;EACE,iBAAA;EACA,qBAAA;AATF;;AAYA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;AATF;;AAYA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,2CAAA;EACA,kBAAA;AATF;AAWE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AATJ;AAYE;EACE,eAAA;EACA,mBAAA;AAVJ;AAaE;EACE,eAAA;EACA,gBAAA;AAXJ;AAaI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAXN;AAeE;EACE,WAAA;EACA,cAAA;AAbJ;AAgBE;EACE,gBAAA;EACA,UAAA;AAdJ;AAgBI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAdN;AAgBM;EACE,cAAA;AAdR;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EAEA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,kBAAA;AAlBF;AAoBE;EACE,iBAAA;EACA,YAAA;AAlBJ;AAqBE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;AAnBJ;AAsBE;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,2CAAA;AApBJ;AAsBI;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AApBN;AAuBI;EACE,kBAAA;EACA,6BAAA;AArBN;;AA0BA;EACE,qDAAA;EAMA,YAAA;EACA,kBAAA;EACA,mBAAA;AA5BF;AA8BE;EACE,eAAA;EACA,mBAAA;AA5BJ;AA+BE;EACE,eAAA;EACA,mBAAA;AA7BJ;AAgCE;EACE,eAAA;EACA,YAAA;AA9BJ;AAiCE;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AA/BJ;;AAmCA;EACE;IACE,eAAA;EAhCF;EAmCA;IACE,0BAAA;EAjCF;EAoCA;IACE,eAAA;EAlCF;AACF","sourcesContent":[".pricing-page {\n  background: #f7f9fc;\n  color: #1a1a1a;\n}\n\n.hero {\n  background: linear-gradient(\n    135deg,\n    #071a3d,\n    #0f2f6b\n  );\n\n  color: white;\n  padding: 120px 20px;\n  text-align: center;\n\n  .hero-content {\n    max-width: 900px;\n    margin: auto;\n  }\n\n  .eyebrow {\n    color: #7eb6ff;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n  }\n\n  h1 {\n    font-size: 64px;\n    font-weight: 800;\n    margin: 20px 0;\n\n    span {\n      color: #5aa8ff;\n    }\n  }\n\n  p {\n    font-size: 20px;\n    opacity: 0.9;\n    max-width: 700px;\n    margin: auto;\n  }\n}\n\n.hero-buttons {\n  margin-top: 40px;\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n}\n\n.btn-primary {\n  background: #1677ff;\n  color: white;\n  border: none;\n  padding: 14px 32px;\n  border-radius: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.btn-secondary {\n  background: transparent;\n  border: 1px solid white;\n  color: white;\n  padding: 14px 32px;\n  border-radius: 12px;\n  cursor: pointer;\n}\n\n.pricing-section {\n  margin-top: -70px;\n  padding: 0 20px 100px;\n}\n\n.pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit,minmax(360px,1fr));\n  gap: 30px;\n  max-width: 1200px;\n  margin: auto;\n}\n\n.pricing-card {\n  background: white;\n  border-radius: 24px;\n  padding: 40px;\n  box-shadow: 0 15px 40px rgba(0,0,0,.08);\n  position: relative;\n\n  .icon {\n    font-size: 40px;\n    color: #1677ff;\n    margin-bottom: 20px;\n  }\n\n  h2 {\n    font-size: 32px;\n    margin-bottom: 10px;\n  }\n\n  .price {\n    font-size: 52px;\n    font-weight: 800;\n\n    span {\n      display: block;\n      font-size: 16px;\n      color: #666;\n      font-weight: 500;\n    }\n  }\n\n  .description {\n    color: #666;\n    margin: 20px 0;\n  }\n\n  ul {\n    list-style: none;\n    padding: 0;\n\n    li {\n      display: flex;\n      gap: 10px;\n      margin-bottom: 14px;\n\n      svg {\n        color: #22c55e;\n      }\n    }\n  }\n}\n\n.featured {\n  border: 3px solid #1677ff;\n}\n\n.popular-badge {\n  position: absolute;\n  top: -15px;\n  right: 30px;\n\n  background: #1677ff;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.card-btn {\n  width: 100%;\n  margin-top: 30px;\n  padding: 14px;\n  border-radius: 12px;\n  border: none;\n  background: #1677ff;\n  color: white;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.comparison {\n  padding: 80px 20px;\n\n  .container {\n    max-width: 1200px;\n    margin: auto;\n  }\n\n  h2 {\n    text-align: center;\n    margin-bottom: 40px;\n    font-size: 42px;\n  }\n\n  table {\n    width: 100%;\n    background: white;\n    border-radius: 20px;\n    overflow: hidden;\n    border-collapse: collapse;\n    box-shadow: 0 15px 40px rgba(0,0,0,.08);\n\n    th {\n      background: #071a3d;\n      color: white;\n      padding: 20px;\n      text-align: left;\n    }\n\n    td {\n      padding: 18px 20px;\n      border-bottom: 1px solid #eee;\n    }\n  }\n}\n\n.cta {\n  background: linear-gradient(\n    135deg,\n    #1677ff,\n    #0055d4\n  );\n\n  color: white;\n  text-align: center;\n  padding: 100px 20px;\n\n  svg {\n    font-size: 50px;\n    margin-bottom: 20px;\n  }\n\n  h2 {\n    font-size: 48px;\n    margin-bottom: 20px;\n  }\n\n  p {\n    font-size: 20px;\n    opacity: 0.9;\n  }\n\n  button {\n    margin-top: 30px;\n    background: white;\n    color: #1677ff;\n    border: none;\n    padding: 16px 36px;\n    border-radius: 12px;\n    font-weight: 700;\n    cursor: pointer;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero h1 {\n    font-size: 42px;\n  }\n\n  .pricing-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .comparison h2 {\n    font-size: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
